<section>
    <div class="cart-item">
        <a [attr.aria-label]="cartAriaLabel" class="cart-cta" (click)="toggleNavMenu()" [uiSref]="pageData.uiSref" [uiParams]="generateUiParams(pageData.uiParams)" (mouseenter)="mouseHoverEvent($event)" (mouseleave)="mouseHoverEvent($event)">
            <xm-media-image [imageOptions]="displayIcon" size="height" class="cart-icon"></xm-media-image>
        </a>
        <span *ngIf="cartCountText" class="cart-count">{{ cartCountText }}</span>
        <div *ngIf="stateActive(pageData)" class="active-state"></div>
    </div>
</section>
